/**
 * フォーム入力値の正規化ユーティリティ
 * 送信前に値を整形する関数群
 */

/** 数字以外を全て除去する */
export const stripNonDigits = (value: string): string => value.replace(/[^0-9]/g, '');

/**
 * 電話番号を国内形式に正規化する
 * autocompleteで +81 や括弧、ハイフンが混入するケースに対応
 *
 * 例:
 * "+81 90-1234-5678" → "09012345678"
 * "090-1234-5678"    → "09012345678"
 * "8190-1234-5678"   → "09012345678" (+なしで81始まりのケース)
 */
export const normalizePhone = (value: string): string => {
  if (!value) return value;
  let cleaned = value.replace(/[^\d+]/g, '');
  if (cleaned.startsWith('+81')) {
    cleaned = `0${cleaned.slice(3)}`;
  } else if (cleaned.startsWith('81') && cleaned.length >= 12) {
    // autocompleteで+が欠落して81始まりになるケース
    cleaned = `0${cleaned.slice(2)}`;
  }
  // +81 090... のように国番号の後に先頭0が残っている場合、00→0に正規化
  cleaned = cleaned.replace(/^00+/, '0');
  return cleaned.replace(/\D/g, '');
};

/** 郵便番号を正規化する（数字以外除去） */
export const normalizeZip = (value: string): string => stripNonDigits(value);
